import { createSlice } from "@reduxjs/toolkit";
import { fetchMissionAssets } from ".";
import { DataStatus } from "../../types";

// Types based on the MissionPlansValidator
type MissionStopFromAPI = {
  id: string;
  duration: number;
  order: number;
  stopPk: string;
  hitchType: number;
};

type MissionPlanFromAPI = {
  id: string;
  loops?: number;
  name: string;
  previous: string;
  semanticMap: string;
  stops: MissionStopFromAPI[];
  timeStamp: string | null;
  updatedAt: string;
};

type OperatorMissionAssetsState = {
  missionAssetsByStopId: Record<string, MissionPlanFromAPI> | null;
  status: DataStatus;
  error: string | null;
};

const initialState: OperatorMissionAssetsState = {
  missionAssetsByStopId: null,
  status: DataStatus.idle,
  error: null,
};

export const Slice = createSlice({
  name: "operatorMissionAssets",
  initialState,
  reducers: {
    resetMissionOperatorAssets: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMissionAssets.pending, (state) => {
        state.status = DataStatus.loading;
        state.error = null;
      })
      .addCase(fetchMissionAssets.fulfilled, (state, action) => {
        state.status = DataStatus.succeeded;
        state.missionAssetsByStopId = action.payload.reduce(
          (
            acc: Record<string, MissionPlanFromAPI>,
            curr: MissionPlanFromAPI
          ) => {
            acc[curr?.stops[0].stopPk] = curr;
            return acc;
          },
          {} as Record<string, MissionPlanFromAPI>
        );
      })
      .addCase(fetchMissionAssets.rejected, (state, action) => {
        state.status = DataStatus.failed;
        state.error = action.error.message ?? "";
      });
  },
});

export default Slice;
